import { InputNumber as AntInputNumber } from 'antd';
import { InputNumberProps } from 'antd/lib/input-number';
import React from 'react';

import cn from 'classnames';
import styles from './InputNumber.module.scss';

export interface IInputNumberProps extends InputNumberProps {
  size?: 'large' | 'middle' | 'small' | undefined;
}

/**
 * InputNumber component
 */
export const InputNumber: React.FC<IInputNumberProps> = ({
  className,
  ...restProps
}) => (
  <AntInputNumber
    className={cn(styles.InputNumber, className)}
    {...restProps}
  />
);
